import { DatePipe, TitleCasePipe } from '@angular/common'
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import { CentralServiceResources as cs } from 'se-resource-types'

@Component({
  selector: 'se-po-persona-choice',
  templateUrl: './persona-choice.component.html',
  styleUrls: ['./persona-choice.component.scss'],
})
export class PersonaChoiceComponent implements OnInit {
  @Input() public profile: cs.Households.UserProfile
  @Output() public edit = new EventEmitter<cs.Households.UserProfile>()
  @Output() public chosen = new EventEmitter<cs.Households.UserProfile>()

  public imageUrl: string
  public ready = false
  public subtitle: string[]
  public missingInfo = false

  constructor(
    private el: ElementRef,
    private seFeTranslationsLoader: SeFeTranslationsLoader,
    private datePipe: DatePipe,
    private titleCasePipe: TitleCasePipe,
    public translateService: TranslateService
  ) {
   //noop
  }

  public async ngOnInit(): Promise<void> {
    await this.initTranslations().then(() => {
      this.setFields()
    })
  }

  public handleHeaderClick($event): void {
    if(this.missingInfo) {
      this.onEdit($event)
    } else {
      this.onChosen()
    }
  }

  public onEdit(e: MouseEvent): void {
    e.stopImmediatePropagation()
    this.edit.emit(this.profile)
  }

  public onChosen(): void {
    this.chosen.emit(this.profile)
  }

  public onKeydown(e: KeyboardEvent): void {
    if (e.code === 'Space' || e.code === 'Enter') {
      this.onChosen()
    }
  }

  private async initTranslations(): Promise<void> {
    await this.seFeTranslationsLoader.load('shared/ui-persona-choice/assets/translations')
  }

  private setFields(): void {
    const dob = this.profile?.persona?.date_of_birth ? this.datePipe.transform(this.profile.persona.date_of_birth, 'MMM d, y') : ''
    const gender = this.profile?.persona?.gender ? this.titleCasePipe.transform(this.profile.persona.gender) : ''
    this.subtitle = [dob, gender].filter(f => !!f)
    if([dob, gender, this.profile?.persona?.first_name, this.profile?.persona?.last_name].some(f => !f)) {
      this.missingInfo = true
      this.subtitle = this.translateService.instant('SE_PO_UI_PERSONA_CHOICE.MISSING_INFO')
    } else {
      this.subtitle = [dob, gender]
      this.missingInfo = false
    }
    this.setImageUrl()
    this.ready = true
  }

  private setImageUrl(): void {
    const profileImages = this.profile?.persona?.profile_images
    this.imageUrl = (profileImages || []).find(i => i.image_type === 'crop')?.url
  }
}
